
export const abbreviate = (text) => {
    var ret = text.split(' ').map(function (item) { return item[0] }).join('');

    ret = ret.substring(0, 2);

    return ret;
};

export const seconds2HMS = (s) => {
    var h = Math.floor(s / 3600); // Horas
    s -= h * 3600;
    var m = Math.floor(s / 60); // Minutos restantes
    s -= m * 60;
    var sH = h.toString().length === 1 ? "0" + h : h;
    return sH + ":" + (m < 10 ? '0' + m : m) + ":" + (s < 10 ? '0' + s : s);
};

export const seconds2MS = (s) => {
    var h = Math.floor(s / 3600); // Horas
    s -= h * 3600;
    var m = Math.floor(s / 60); // Minutos restantes
    s -= m * 60;
    return (m < 10 ? '0' + m : m) + ":" + (s < 10 ? '0' + s : s);
};

export const notify = (title, msg, play) => {
    if (Notification.permission !== "granted") {
        Notification.requestPermission();
    } else {


        let notification = new Notification(title, {
            body: msg,
            icon: `${window.location.origin}${window.location.pathname}/favicon.ico`
        });
        notification.onshow = function () {
            setTimeout(function () {
                notification.close();
            }, 3500);

            if (play) {
                var audio = new Audio('resources/notification.mp3');
                audio.play();
            }
        }
    }
}


